import { Chip, CircularProgress, Tooltip, Typography } from '@mui/material';
import { action, computed, makeObservable, observable } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import { Processo } from '../../modelo';
import { IAutocomplete } from '../../modelo/Autocomplete';
import { MovimentoGEDTO } from '../../modelo/MinutaMovimentos';
import MovimentoService from '../../services/MovimentoService';
import MovimentoCNJStore from '../../store/MovimentoCNJStore';
import ModalComplementoMovimento from './ModalComplementoMovimento';

interface IPropsChipMovimentoCNJ {
    movimento: MovimentoGEDTO;
    processo: Processo;
    callbackExcluir?: (movimentoExcluido: MovimentoGEDTO) => any
}


class ChipMovimentoCNJ extends React.Component<IPropsChipMovimentoCNJ> {
    localMovimento: MovimentoGEDTO;

    constructor(props: IPropsChipMovimentoCNJ) {
        super(props);
        makeObservable(this, {
            localMovimento: observable,
            componentDidUpdate: action,
            movimento: computed,
            borderColor: computed
        });
        this.localMovimento = props.movimento;
    }

    componentDidUpdate(prevProps: IPropsChipMovimentoCNJ) {
        if (prevProps.movimento !== this.props.movimento) {
            this.localMovimento = this.props.movimento;
        }
    }

    get movimento() {
        return this.localMovimento;
    }

    handleClickRemoverMovimento = () => {
        if (this.props.callbackExcluir) {
            this.props.callbackExcluir(this.movimento);
        } else {
            MovimentoService.removerMovimento(this.props.processo, this.movimento);
        }
    }

    get labelChip() {
        return (
            <div className='divFlexRow aCenter'>
                <Tooltip placement='top' title={MovimentoService.getDescricaoMovimento(this.movimento, this.props.processo)}>
                    <Typography>
                        {this.movimento.codMovimentoCnj}
                    </Typography>
                </Tooltip>
                <ModalComplementoMovimento movimento={this.movimento} processo={this.props.processo} apenasBotoes />
            </div>
        );
    }

    buscaMovimentoPorCodMovimentacao = () => {
        let retorno: IAutocomplete<MovimentoGEDTO>;
        if (this.movimento.origem === "P") {
            retorno = MovimentoCNJStore.movimentosPJe.find(movimento => {
                return this.movimento.codMovimentoCnj === movimento.valor.codMovimentoCnj;
            })
        } else {
            retorno = MovimentoCNJStore.movimentosLegado.find(movimento => {
                return this.movimento.codMovimentoCnj === movimento.valor.codMovimentoCnj;
            })
        }
        return retorno?.valor;
    }

    get borderColor() {
        const movimentoEncontrado = this.buscaMovimentoPorCodMovimentacao();
        if (movimentoEncontrado?.tipoMovimento === "1") {
            return "error" //cor vermelha para o CHIP - decisões terminativas
        } else if (movimentoEncontrado?.tipoMovimento === "2") {
            return "primary" //cor azul para o CHIP - decisões interlocutórias
        } else {
            return "success" //cor verde para o CHIP - despachos
        }
    }

    render() {
        if (!this.movimento) {
            return <CircularProgress />;
        }

        return (
            <>
                <Chip onDelete={this.handleClickRemoverMovimento}
                    label={this.labelChip} color={this.borderColor} sx={{ mr: '8px', borderColor: this.borderColor }} variant="outlined" />
                <ModalComplementoMovimento key={'modal-' + this.movimento.id + '-' + this.movimento.codMovimentoCnj} movimento={this.movimento} processo={this.props.processo} apenasBotoes={false} />
            </>
        );
    }
}

export default observer(ChipMovimentoCNJ);
